// frontend/src/services/planService.js
import { configuredAxios as api } from './axiosConfig';

const planService = {
  /**
   * Obtém todos os planos de assinatura disponíveis.
   */
  async getAllPlans() {
    try {
      const response = await api.get('/plans');
      return response.data; 
    } catch (error) {
      console.error('Erro no planService ao buscar planos:', error);
      throw new Error(error.message || 'Falha ao carregar planos de assinatura.');
    }
  },

  /**
   * Cria um novo plano de assinatura (admin).
   */
  async createPlan(planData) {
    try {
      const response = await api.post('/plans', planData);
      return response.data;
    } catch (error) {
      console.error('Erro no planService ao criar plano:', error);
      throw new Error(error.message || 'Falha ao criar plano.');
    }
  },

  /**
   * Atualiza um plano existente (admin).
   */
  async updatePlan(planId, planData) {
    try {
      const response = await api.put(`/plans/${planId}`, planData);
      return response.data;
    } catch (error) {
      console.error('Erro no planService ao atualizar plano:', error);
      throw new Error(error.message || 'Falha ao atualizar plano.');
    }
  },

  /**
   * Deleta um plano (admin).
   */
  async deletePlan(planId) {
    try {
      const response = await api.delete(`/plans/${planId}`);
      return response.data;
    } catch (error) {
      console.error('Erro no planService ao deletar plano:', error);
      throw new Error(error.message || 'Falha ao deletar plano.');
    }
  }
};

export default planService;
